export * from 'cf-core/src/images'
export const Hero404 = 'https://d24rddnpxh8ji7.cloudfront.net/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://d24rddnpxh8ji7.cloudfront.net/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/zomato_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/instagram_white.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1590261442/general/cflogo.png'
export const about = 'https://ds1lb5eqnn03z.cloudfront.net/about.webp'
export const contactbg = 'https://ds1lb5eqnn03z.cloudfront.net/contactbg.webp'
export const foodGallery =
  'https://ds1lb5eqnn03z.cloudfront.net/menu040820241.jpeg'
export const foodGallery2 =
  'https://ds1lb5eqnn03z.cloudfront.net/menu040820242.jpeg'
export const hero = 'https://ds1lb5eqnn03z.cloudfront.net/herobg.webp'
export const heroText = 'https://ds1lb5eqnn03z.cloudfront.net/heroText.webp'
export const locationMap =
  'https://ds1lb5eqnn03z.cloudfront.net/locationMap.webp'
export const mobileAbout =
  'https://ds1lb5eqnn03z.cloudfront.net/mobileAbout.webp'
export const mobileContactbg =
  'https://ds1lb5eqnn03z.cloudfront.net/mobileContactBg.webp'
export const mobileGallery =
  'https://ds1lb5eqnn03z.cloudfront.net/misoyaMobileMenu1.jpeg'
export const mobileGallery2 =
  'https://ds1lb5eqnn03z.cloudfront.net/misoyaMobileMenu2.jpeg'
export const mobileGallery3 =
  'https://ds1lb5eqnn03z.cloudfront.net/misoyaMobileMenu3.jpeg'
export const mobileGallery4 =
  'https://ds1lb5eqnn03z.cloudfront.net/misoyaMobileMenu4.jpeg'
export const mobileHero = 'https://ds1lb5eqnn03z.cloudfront.net/mobileHero.webp'
export const mobileMap = 'https://ds1lb5eqnn03z.cloudfront.net/mobileMap.webp'
export const mobileHeroText =
  'https://ds1lb5eqnn03z.cloudfront.net/mobileText.webp'
export const mobilePromotion =
  'https://ds1lb5eqnn03z.cloudfront.net/promotionsMobile.jpg'
export const orderPickupButton =
  'https://ds1lb5eqnn03z.cloudfront.net/OrderPickupButton.webp'
export const promotions = 'https://ds1lb5eqnn03z.cloudfront.net/promotions.jpg'

export { default as menu1 } from './menu1.jpeg'
export { default as menu2 } from './menu2.jpeg'
export { default as mobileMenu1 } from './mobileMenu1.jpeg'
export { default as mobileMenu2 } from './mobileMenu2.jpeg'
export { default as mobileMenu3 } from './mobileMenu3.jpeg'
export { default as mobileMenu4 } from './mobileMenu4.jpeg'
